export default __webpack_public_path__ + "static/media/user-default.847b30c8.png";